<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Департаменты</p>

      <template v-if="isAccessAllowed">
        <div class="mb-4">
          <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
        </div>

        <div class="table-container mb-16 js-table-arrow">
          <table class="stockTable">
            <thead>
              <tr>
                <th>ID</th>
                <th>Краткое наименование</th>
                <th>Полное наименование</th>
                <th>Статус</th>
              </tr>
              <tr>
                <th></th>
                <th class="filter" colspan="2">
                  <FilterInput v-model="filter.name" placeholder="Найти..." @valueChangedDebounced="changeFilter" />
                </th>
                <th class="filter">
                  <FilterActiveInput
                    v-model="filter.isActive"
                    placeholder="(Все)"
                    @valueChangedDebounced="changeFilter"
                  />
                </th>
              </tr>
            </thead>
            <tbody v-if="page.items?.length && !isLoading">
              <tr v-for="item in page.items" :key="item.id">
                <td>{{ item.sub }}</td>
                <td>{{ item.shotName }}</td>
                <td>{{ item.name }}</td>
                <td>
                  {{ item.isActive ? 'действ.' : 'не действ.' }}
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isLoading">
              <tr>
                <td class="text-center" colspan="4">Загрузка...</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-center" colspan="4">Нет данных.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="page.pagesTotal > 1">
          <Pagination
            :pageCount="page.pagesTotal"
            :currentPage="page.pageNumber"
            @change="onPageChange($event, false)"
            @more="onPageChange($event, true)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import FilterActiveInput from '../../../common/components/FilterActiveInput.vue';
  import FilterInput from '../../../common/components/FilterInput.vue';
  import API from '../api/department';

  const PERMISSIONS = {
    view: Constants.Permissions.DeptView,
  };

  export default {
    name: 'Departments',
    components: {
      FilterActiveInput,
      FilterInput,
      DefaultFilter,
    },
    mixins: [security],
    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: {
          name: null,
          isActive: null,
        },
        page: {},
        isLoading: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      loadFilter(this.$options.name).then((response) => {
        let filter = response;
        if (filter) {
          this.filter = filter;
        }
        this.loadPage();
      });
    },
    methods: {
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      loadPage(append) {
        this.isLoading = !append;
        const request = Object.assign(this.filter, this.request);
        API.search(request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              //добавляем к существующему
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
    },
  };
</script>
